const SERVICERS_PREFIX = '@@servicers/';

export const SERVICERS_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${SERVICERS_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${SERVICERS_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${SERVICERS_PREFIX}FETCH_LIST_FAILURE`,
}

export const SERVICERS_CONFIG = {
    PAGE_SIZE: 20,
    CACHE_TIME: 60 * 1000,
}
